import React from "react";
import { View, StyleSheet } from "react-native";
import NtText from "../../../components/NtText";
import colors from "../../../config/colors";

function NtCaseStudyDescription({ style, ...otherProbs }) {
  return <NtText style={[styles.text, style]} {...otherProbs} />;
}

const styles = StyleSheet.create({
  text: {
    fontSize: 18,
    color: "white",
    fontStyle: "italic",
    lineHeight: 25,
  },
});

export default NtCaseStudyDescription;
